import { Injectable } from '@angular/core';

@Injectable()
export class LibraryUtilsService {
  constructor() {}

  public getLangCode(languageCode: string): string {
    switch (languageCode.toLowerCase()) {
      case 'fr':
        return 'fr_fr';
      case 'de':
        return 'de_de';
      case 'en':
        return 'en_uk';
      case 'us':
        return 'en_us';
      case 'es':
        return 'es_es';
      case 'it':
        return 'it_it';
      default:
        return 'en_uk';
    }
  }
}
